// Zinsdelen voor de samenvatting van een herhaling in elke taal (packages/domain
// recurrence/summaryLang.ts; oprichter 1 okt: alles in zes talen). Sleutels in
// `a.recurrenceText.*` (app.nl.ts). Nederlands zelf komt uit de vaste tekst van summary.ts; deze
// nl-zinnen zijn de basis en de terugval voor de andere talen en geven dezelfde uitkomst.
// {period} = "Elke week" / "Om de week" / "Elke 3 weken"; {days} = weekdagen als lijst.
export const appRecurrenceNl = {
    once: 'Eenmalig',
    everyDay: 'Elke dag',
    everyWorkday: 'Elke werkdag',
    everyWeek: 'Elke week',
    everyMonth: 'Elke maand',
    everyYear: 'Elk jaar',
    everyWeekdays: 'Elke {days}',
    otherDay: 'Om de dag',
    otherWeek: 'Om de week',
    otherMonth: 'Om de maand',
    otherYear: 'Om het jaar',
    nDays: { one: 'Elke {count} dag', other: 'Elke {count} dagen' },
    nWeeks: { one: 'Elke {count} week', other: 'Elke {count} weken' },
    nMonths: { one: 'Elke {count} maand', other: 'Elke {count} maanden' },
    nYears: { one: 'Elke {count} jaar', other: 'Elke {count} jaar' },
    dailyOnlyOn: '{period}, alleen op {days}',
    weeklyOn: '{period} op {days}',
    weeklyAllDays: '{period} op alle dagen',
    weeklyWorkdays: '{period} op werkdagen',
    monthlyOrdinal: 'Elke {ordinals} van de maand',
    monthlyOrdinalPeriod: '{period} op de {ordinals}',
    monthlyOn: '{period} op {days}',
    ifWeekday: '{text} als dat een {days} is',
    monthDay: 'de {day}e',
    lastDay: 'de laatste dag',
    nthLastDay: 'de {ordinal} dag',
    yearlyOrdinal: '{period} op de {ordinals} van {months}',
    yearlyOn: '{period} op {date}',
    yearlyDays: '{period} op {days} van {months}',
    dayMonth: '{day} {month}',
    ordinalWeekday: '{ordinals} {weekday}',
    anyWeekday: 'elke {weekday}',
    ord1: 'eerste',
    ord2: 'tweede',
    ord3: 'derde',
    ord4: 'vierde',
    ord5: 'vijfde',
    ordLast: 'laatste',
    ordLast2: 'een-na-laatste',
    ordLast3: 'twee-na-laatste',
    ordLast4: 'drie-na-laatste',
    ordLast5: 'vier-na-laatste',
    ordN: '{n}e',
    evenWeeks: '{text} in even weken',
    oddWeeks: '{text} in oneven weken',
    at: '{text} om {time}',
    fromTo: '{text} van {start} tot {end}',
    times: { one: '{text}, {count} keer', other: '{text}, {count} keer' },
    until: '{text}, tot en met {date}',
    listAnd: '{a} en {b}',
    listSep: ', ',
};
//# sourceMappingURL=recurrenceApp.nl.js.map